
const access_token = "access_token_dev_ic"; // access_token_ic
const refresh_token = "refresh_token_dev_ic"; // refresh_token_ic
const language_key = "language_ic";

export { access_token, refresh_token, language_key };
